import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, FormStore, inject, Input } from 'Mri.Web.Common';
import * as React from 'react';
import { Form, FormGroup } from 'reactstrap';
import { AppStore } from '../../../Core/AppStore';
import { ActiveDisplay } from '../../ActiveDisplay';
import { DisplaysStore } from '../../DisplaysStore';

export interface IAdvancedDisplaySettingsFormProps {
    readonly advancedSettingsStore: FormStore<Mri.Displays.DisplaySmartVuSettings>;
}

@autoinject
@observer
export class AdvancedDisplaySettingsForm extends React.Component<IAdvancedDisplaySettingsFormProps> {
    public render() {
        const { advancedSettingsStore } = this.props;

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <h3>Advanced Settings</h3>

                        <Form>
                            <FormGroup color={advancedSettingsStore.fields.disableAutomaticallyManagedIp.state}>
                                <Input
                                    type="checkbox"
                                    field={advancedSettingsStore.fields.disableAutomaticallyManagedIp}
                                    className="ms-1"
                                />
                                <span>Disable Automatically Managed IP</span>
                                <small className="form-text text-muted">
                                    Turns off Display's automatically setting their remote Display Board IPs in
                                    SmartVu's settings. Useful when a display's network is incorrectly setting the
                                    remote IP and loosing connectivity
                                </small>
                            </FormGroup>

                            <FormGroup color={advancedSettingsStore.fields.disableGpsGeocoding.state}>
                                <Input
                                    type="checkbox"
                                    field={advancedSettingsStore.fields.disableGpsGeocoding}
                                    className="ms-1"
                                />
                                <span>Disable GPS Geocoding</span>
                                <small className="form-text text-muted">
                                    Turns off Display's automatically setting their Unit Location address whenever GPS
                                    information is returned. Useful when a display's GPS sensor is imporperly setting
                                    the Address field
                                </small>
                            </FormGroup>

                            {
                                // <FormGroup color={advancedSettingsStore.fields.disableJobScheduler.state}>
                                // <Input
                                // type="checkbox"
                                // field={advancedSettingsStore.fields.disableJobScheduler}
                                // className="ms-1"
                                // />
                                // <span>Disable Job Scheduler</span>
                                // </FormGroup>
                            }

                            <FormGroup color={advancedSettingsStore.fields.disableOnDemandJobs.state}>
                                <Input
                                    type="checkbox"
                                    field={advancedSettingsStore.fields.disableOnDemandJobs}
                                    className="ms-1"
                                />
                                <span>Disable On-Demand Jobs</span>
                                <small className="form-text text-muted">
                                    Turns off on-demand polling when viewing a display page. This should only be used
                                    when something really bad is happening with StatusPolls & TelemetryPolls when
                                    someone is clicking on a Display details page. 15-min polls will still occur, but
                                    the on-demand instantaneous polls will stop
                                </small>
                            </FormGroup>

                            <FormGroup color={advancedSettingsStore.fields.disableProxyMriPrivateLookup.state}>
                                <Input
                                    type="checkbox"
                                    field={advancedSettingsStore.fields.disableProxyMriPrivateLookup}
                                    className="ms-1"
                                />
                                <span>Disable Proxy Mri-Private Lookup</span>
                                <small className="form-text text-muted">
                                    Turns off the StatusVu proxy from dynamically determinig MriPrivate and/or password
                                    login information when routing to a remote display's StatusVu page. This is useful
                                    when a display has ran out of RAM or having other binary API issues preventing
                                    SmartVu from succesfully proxying to StatusVu
                                </small>
                            </FormGroup>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}
